import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpPreviousRounds
     * @memberof app
     *
     * @restrict E
     *
     * @description
     * Display previous rounds with a toggle for tabular and graphical view.
     *
     * @param {Object[]} windows The auction windows matching the backend's List of `AuctionWindowDto`s.
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpPreviousRounds', pkpPreviousRounds);

    function pkpPreviousRounds() {
        return {
            restrict: 'E',
            scope: {
                windows: '=',
                title: '@'
            },
            template: require('app/_directives/pkp-previous-rounds.directive.html')
        };
    }
})();
